// 新增关键字
import fetch from '@/plugin/axios'

export function addProductCate (data) {
  return fetch({
    url: '/api/order/product/categories',
    method: 'Post',
    data: data
  })
}

// 关键字列表
export function getProductCateList (data) {
  return fetch({
    url: '/api/order/product/categories',
    method: 'Get',
    params: data
  })
}

export function getProductCateOption () {
  return fetch({
    url: '/api/order/product/categories/option',
    method: 'Get'
  })
}

// 删除关键字
export function removeProductCate (id) {
  return fetch({
    url: `/api/order/product/categories/${id}`,
    method: 'Delete'
  })
}

// 关键字信息
export function getProductCateInfo (id) {
  return fetch({
    url: `/api/order/product/categories/${id}`,
    method: 'Get'
  })
}

// 修改关键字
export function updateProductCate (id, data) {
  return fetch({
    url: `/api/order/product/categories/${id}`,
    method: 'Put',
    data: data
  })
}

// 添加产品
export function addProduct (data) {
  return fetch({
    url: '/api/order/service-products',
    method: 'Post',
    data: data
  })
}

// 获取产品列表
export function getProductList (data) {
  return fetch({
    url: '/api/order/service-products/list',
    method: 'Post',
    data: data
  })
}

// 删除产品
export function removeProduct (id) {
  return fetch({
    url: `/api/order/service-products/${id}`,
    method: 'Delete'
  })
}

// 获取产品信息
export function getProductInfo (id) {
  return fetch({
    url: `/api/order/service-products/${id}`,
    method: 'Get'
  })
}

// 修改产品
export function updateProduct (id, data) {
  return fetch({
    url: `/api/order/service-products/${id}`,
    method: 'Put',
    data: data
  })
}

// 获取产品规格名列表
export function getProductSpecList (data) {
  return fetch({
    url: '/api/order/product-spec-names/list',
    method: 'Post',
    data: data
  })
}

// 添加产品规格名
export function addProductSpec (data) {
  return fetch({
    url: '/api/order/product-spec-names/add',
    method: 'Post',
    data: data
  })
}

// 删除产品规格名
export function removeProductSpec (id) {
  return fetch({
    url: `/api/order/product-spec-names/${id}`,
    method: 'Delete'
  })
}
// 获取产品规格名信息
export function getProductSpecInfo (id) {
  return fetch({
    url: `/api/order/product-spec-names/${id}`,
    method: 'Get'
  })
}

// 修改产品规格名
export function updateProductSpec (data) {
  return fetch({
    url: `/api/order/product-spec-names/update`,
    method: 'Post',
    data: data
  })
}

// 获取产品规格名选项
export function getProductSpecOption () {
  return fetch({
    url: '/api/order/product-spec-names/options',
    method: 'Get'
  })
}

// 规格值列表
export function getProductSpecValueList (specId) {
  return fetch({
    url: `/api/order/product-spec-values/list/${specId}`,
    method: 'Get'
  })
}

// 更新规格值列表
export function updateProductSpecValue (specId, data) {
  return fetch({
    url: `/api/order/product-spec-values/update/${specId}`,
    method: 'Post',
    data: data
  })
}

// 根据 ids 获取规格值列表
export function getProductSpecValueListByIds (data) {
  return fetch({
    url: `/api/order/product-spec-values/ids`,
    method: 'Post',
    data: data
  })
}
